export default __webpack_public_path__ + "static/media/Roadmap-bg.8860b73b.png";